import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["seats", "people", "total"]
  static values = { price: Number, currency: String, locale: String, one: String, other: String }

  connect() {
    this.formatter = new Intl.NumberFormat(this.localeValue)
    this.update()
  }

  update() {
    const seats = Number.parseInt(this.seatsTarget.value, 10) || 1
    const people = seats === 1 ? this.oneValue : this.otherValue.replace("%{count}", seats)

    this.peopleTarget.textContent = people
    this.seatsTarget.setAttribute("aria-valuetext", people)
    this.totalTarget.textContent = `${this.currencyValue} ${this.formatter.format(this.priceValue * seats)}`
  }
}
